import { Phone, Mail, Lock, MapPin, Pencil } from "lucide-react";

// Icone colorate dei campi Rubrica (stesse in scheda e card).
const Box = ({ color, children, title }) => (
  <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md relative" style={{ background: `${color}22`, color }} title={title}>{children}</span>
);
export const IconTel = () => <Box color="#16a34a" title="Telefono"><Phone className="h-3.5 w-3.5" /></Box>;
export const IconEmail = () => <Box color="#f97316" title="Email"><Mail className="h-3.5 w-3.5" /></Box>;
export const IconPec = () => (
  <Box color="#2563eb" title="PEC"><Mail className="h-3.5 w-3.5" /><Lock className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-sm bg-white p-[1px]" strokeWidth={3} /></Box>
);
export const IconAddr = () => <Box color="#dc2626" title="Indirizzo"><MapPin className="h-3.5 w-3.5" /></Box>;
export const IconNote = () => <Box color="#ca8a04" title="Nota"><Pencil className="h-3.5 w-3.5" /></Box>;
